import styled from "styled-components";
import { Container, CardHeader, CardHeaderTitle } from "../DefaultImports";
import { OverviewButton } from "../overview/overviewStyles";

export const DirectoryPage = styled(Container)`
  padding: 12px 16px 28px; min-width: 0; color: #425a52;
  @media (max-width: 600px) { padding: 8px 10px 24px; }
`;
export const DirectoryHeader = styled(CardHeader)`
  gap: 12px; flex-wrap: wrap; min-height: 44px; margin-bottom: 0;
  padding-bottom: 16px; border-bottom: 1px solid #e6eeea;
`;
export const DirectoryTitle = styled(CardHeaderTitle)`font-size: 22px; line-height: 1.4;`;
export const Toolbar = styled.div`
  display: flex; align-items: center; justify-content: space-between;
  flex-wrap: wrap; gap: 12px; padding: 18px 0;
`;
export const SearchField = styled.label`
  display: flex; align-items: center; gap: 9px; width: min(100%, 420px);
  min-height: 40px; padding: 0 12px; margin: 0; border: 1px solid #dce6e1;
  border-radius: 9px; background: #fff; color: #7b958b;
  &:focus-within { border-color: #8ca99c; box-shadow: 0 0 0 3px rgba(140,169,156,.13); }
  svg { width: 17px; height: 17px; flex-shrink: 0; stroke-width: 1.75; }
  input {
    width: 100%; min-width: 0; padding: 9px 0; border: 0; background: transparent;
    color: #425a52; font: inherit; font-size: 13px;
    &::placeholder { color: #84958e; }
    &&:focus, &&:focus-visible { outline: none; box-shadow: none; }
  }
  @media (max-width: 600px) { width: 100%; }
`;
export const ResultCount = styled.span`
  font-size: 12px; color: #788b81; font-variant-numeric: tabular-nums;
`;
export const DirectoryList = styled.ul`
  list-style: none; padding: 0; margin: 0; border: 1px solid #e1e9e4;
  border-radius: 12px; background: #fff;
`;
export const DirectoryRow = styled.li`
  display: grid; grid-template-columns: minmax(180px, 1fr) minmax(180px, 1fr) auto;
  gap: 16px; align-items: center; min-width: 0; padding: 16px;
  border-bottom: 1px solid #edf1ee;
  &:last-child { border-bottom: 0; }
  &:hover { background: #fafcfb; }
  &:first-child { border-radius: 12px 12px 0 0; }
  &:last-child { border-radius: 0 0 12px 12px; }
  & > * { min-width: 0; }
  svg { width: 17px; height: 17px; flex-shrink: 0; stroke-width: 1.75; }
  @media (max-width: 1000px) {
    grid-template-columns: minmax(0, 1fr) auto; gap: 8px 16px;
    & > :nth-child(2) { grid-column: 1; padding-left: 42px; }
    & > :nth-child(3) { grid-column: 2; grid-row: 1 / 3; }
  }
  @media (max-width: 640px) {
    grid-template-columns: minmax(0, 1fr); padding: 14px 12px;
    & > :nth-child(3) { grid-column: 1; grid-row: auto; justify-content: flex-start; margin-top: 5px; }
  }
`;
export const Identity = styled.div`
  display: flex; align-items: center; gap: 10px; font-size: 13px;
  strong { font-weight: 650; overflow-wrap: anywhere; }
`;
export const Avatar = styled.span`
  display: inline-flex; align-items: center; justify-content: center;
  width: 32px; height: 32px; flex: 0 0 32px; border-radius: 9px;
  color: #729187; background: #f0f5f2;
`;
export const CustomerButton = styled.button`
  display: inline-flex; align-items: center; gap: 8px; border: 0; padding: 4px 0;
  background: transparent; color: #3d574c; font: inherit; font-weight: 650;
  text-align: left; min-width: 0; overflow-wrap: anywhere; cursor: pointer;
  &:hover { color: #ce613e; }
  svg { color: #84998f; width: 15px; height: 15px; }
`;
export const Contact = styled.div`
  display: flex; align-items: center; gap: 8px; color: #70867a; font-size: 12px;
  span { min-width: 0; overflow-wrap: anywhere; }
`;
export const Actions = styled.div`
  display: flex; justify-content: flex-end; align-items: center; flex-wrap: wrap; gap: 6px;
`;
export const DirectoryButton = styled(OverviewButton)`
  min-height: 34px; padding: 7px 10px; line-height: 1.3;
  &:disabled { cursor: not-allowed; }
  @media (max-width: 380px) { font-size: 11px; padding: 7px 8px; gap: 5px; }
`;
export const IconButton = styled(DirectoryButton)`width: 32px; min-height: 32px; padding: 7px; border-color: transparent;`;
export const Metric = styled.span`
  display: inline-flex; align-items: center; gap: 7px; border-radius: 7px;
  padding: 6px 9px; font-size: 11px; line-height: 1.5;
  background: ${({ $warning }) => $warning ? "#fff4ee" : "#f3f7f5"};
  color: ${({ $warning }) => $warning ? "#a76145" : "#657e70"};
  strong { font-size: 13px; color: inherit; font-weight: 700; font-variant-numeric: tabular-nums; }
`;
export const EmptyState = styled.div`
  padding: 36px 16px; text-align: center; font-size: 13px; line-height: 1.7;
  color: #768c7f; border: 1px solid #e3ebe6; border-radius: 12px;
  p { margin: 10px 0 0; }
  > svg { width: 26px; height: 26px; color: #8ba69a; }
`;
export const Pagination = styled.nav`
  display: flex; align-items: center; justify-content: flex-end; gap: 12px;
  padding-top: 16px; font-size: 12px; color: #72877a;
  span { font-variant-numeric: tabular-nums; }
`;
